import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
export const withRouter = (component) => () => (_jsx(BrowserRouter, { children: _jsx(Suspense, { fallback: "", children: component() }) }));
